import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1,
  class: "collapse-section"
};
const _hoisted_5 = {
  class: "collapse-items"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  key: 3,
  class: "collapse-section"
};
const _hoisted_8 = {
  class: "collapse-items"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = {
  key: 0
};
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  class: "center-rl-logo"
};
const _hoisted_17 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_menu = _resolveComponent("el-menu");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
    id: "fill-sidebar-gap",
    class: _normalizeClass({
      'open': !$setup.sidebar.states.isSidebarClose
    })
  }, null, 2), _createElementVNode("div", {
    id: "mask",
    class: _normalizeClass({
      'open': !$setup.sidebar.states.isSidebarClose
    }),
    onClick: _cache[0] || (_cache[0] = $event => $setup.sidebar.mutations.switchSidebarClose(false))
  }, null, 2), _createElementVNode("div", {
    id: "sidebar-content",
    class: _normalizeClass({
      'open': !$setup.sidebar.states.isSidebarClose
    })
  }, [_createVNode(_component_el_menu, {
    "default-active": $setup.state.activeLink,
    class: "el-menu-vertical-demo",
    collapse: $setup.sidebar.states.isSidebarClose,
    "collapse-transition": false
  }, {
    default: _withCtx(() => [_createVNode(_component_el_menu_item, {
      index: "home",
      class: "tooltip",
      "data-content": _ctx.$t('SIDEBAR.HOME'),
      onClick: _cache[1] || (_cache[1] = $event => {
        $setup.closeSidebar();
        $setup.gaTrackButtonClick('leftmenu-home');
        $setup.routerPush($event);
      })
    }, {
      default: _withCtx(() => [_cache[13] || (_cache[13] = _createElementVNode("div", null, [_createElementVNode("svg", {
        viewBox: "0 0 34 34",
        class: "sidebar-logo"
      }, [_createElementVNode("use", {
        "xlink:href": "#home"
      })])], -1)), !$setup.sidebar.states.isSidebarClose ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t("SIDEBAR.HOME")), 1)) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["data-content"]), _createVNode(_component_el_menu_item, {
      index: "library",
      class: "tooltip",
      "data-content": _ctx.$t('SIDEBAR.LIBRARY'),
      onClick: _cache[2] || (_cache[2] = $event => {
        $setup.closeSidebar();
        $setup.gaTrackButtonClick('leftmenu-library');
        $setup.routerPush($event);
      })
    }, {
      default: _withCtx(() => [_cache[14] || (_cache[14] = _createElementVNode("div", null, [_createElementVNode("svg", {
        viewBox: "0 0 34 34",
        class: "sidebar-logo"
      }, [_createElementVNode("use", {
        "xlink:href": "#library"
      })])], -1)), !$setup.sidebar.states.isSidebarClose ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t("SIDEBAR.LIBRARY")), 1)) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["data-content"]), _createVNode(_component_el_menu_item, {
      index: "whats-new",
      class: "tooltip",
      "data-content": _ctx.$t('SIDEBAR.WHATS_NEW'),
      onClick: _cache[3] || (_cache[3] = $event => {
        $setup.closeSidebar();
        $setup.gaTrackButtonClick('leftmenu-whats-new');
        $setup.routerPush($event);
      })
    }, {
      default: _withCtx(() => [_cache[15] || (_cache[15] = _createElementVNode("div", null, [_createElementVNode("svg", {
        viewBox: "0 0 34 34",
        class: "sidebar-logo"
      }, [_createElementVNode("use", {
        "xlink:href": "#whats-new"
      })])], -1)), !$setup.sidebar.states.isSidebarClose ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t("SIDEBAR.WHATS_NEW")), 1)) : _createCommentVNode("", true), _cache[16] || (_cache[16] = _createElementVNode("div", {
        class: "label"
      }, "New", -1))]),
      _: 1
    }, 8, ["data-content"]), $setup.sidebar.states.isSidebarClose ? (_openBlock(), _createBlock(_component_el_menu_item, {
      key: 0,
      index: "getting-started",
      class: "tooltip",
      "data-content": _ctx.$t('SIDEBAR.GETTING_STARTED'),
      onClick: $setup.openSidebar
    }, {
      default: _withCtx(() => _cache[17] || (_cache[17] = [_createElementVNode("div", null, [_createElementVNode("svg", {
        viewBox: "0 0 34 34",
        class: "sidebar-logo"
      }, [_createElementVNode("use", {
        "xlink:href": "#getting-started"
      })])], -1)])),
      _: 1
    }, 8, ["data-content", "onClick"])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", {
      class: "collapse-header",
      onClick: _cache[4] || (_cache[4] = (...args) => $setup.toggleGettingStarted && $setup.toggleGettingStarted(...args))
    }, [_cache[18] || (_cache[18] = _createElementVNode("svg", {
      viewBox: "0 0 34 34",
      class: "sidebar-logo"
    }, [_createElementVNode("use", {
      "xlink:href": "#getting-started"
    })], -1)), _createElementVNode("div", null, _toDisplayString(_ctx.$t("SIDEBAR.GETTING_STARTED")), 1), _cache[19] || (_cache[19] = _createElementVNode("div", {
      class: "label"
    }, "New", -1)), _createElementVNode("span", {
      class: _normalizeClass(["collapse-arrow", {
        open: $setup.isGettingStartedOpen
      }])
    }, null, 2)]), _withDirectives(_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sidebar.states.gettingStartedList, item => {
      return _openBlock(), _createElementBlock("div", {
        key: item.url,
        class: "collapse-item",
        onClick: $event => $setup.goGettingStarted(item.url)
      }, _toDisplayString(item.name), 9, _hoisted_6);
    }), 128))], 512), [[_vShow, $setup.isGettingStartedOpen]])])), $setup.sidebar.states.isSidebarClose ? (_openBlock(), _createBlock(_component_el_menu_item, {
      key: 2,
      index: "pipeline",
      class: _normalizeClass(["tooltip", {
        active: $setup.isPipelineRoute
      }]),
      "data-content": _ctx.$t('SIDEBAR.PIPELINE'),
      onClick: $setup.openSidebar
    }, {
      default: _withCtx(() => _cache[20] || (_cache[20] = [_createElementVNode("div", null, [_createElementVNode("svg", {
        viewBox: "0 0 34 34",
        class: "sidebar-logo"
      }, [_createElementVNode("use", {
        "xlink:href": "#pipeline"
      })])], -1)])),
      _: 1
    }, 8, ["class", "data-content", "onClick"])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", {
      class: "collapse-header",
      onClick: _cache[5] || (_cache[5] = (...args) => $setup.togglePipeline && $setup.togglePipeline(...args))
    }, [_cache[21] || (_cache[21] = _createElementVNode("svg", {
      viewBox: "0 0 34 34",
      class: "sidebar-logo"
    }, [_createElementVNode("use", {
      "xlink:href": "#pipeline"
    })], -1)), _createElementVNode("div", null, _toDisplayString(_ctx.$t("SIDEBAR.PIPELINE")), 1), _cache[22] || (_cache[22] = _createElementVNode("div", {
      class: "label"
    }, "New", -1)), _createElementVNode("span", {
      class: _normalizeClass(["collapse-arrow", {
        open: $setup.isPipelineOpen
      }])
    }, null, 2)]), _withDirectives(_createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sidebar.states.pipelineList, item => {
      return _openBlock(), _createElementBlock("div", {
        key: item.urlName,
        class: _normalizeClass(["collapse-item", {
          active: $setup.isPipelineActive(item.urlName)
        }]),
        onClick: $event => $setup.goPipeline(item.urlName)
      }, _toDisplayString(item.name), 11, _hoisted_9);
    }), 128))], 512), [[_vShow, $setup.isPipelineOpen]])])), _createVNode(_component_el_menu_item, {
      index: "skill-paths",
      class: "tooltip",
      "data-content": _ctx.$t('SIDEBAR.SKILL_PATH'),
      onClick: _cache[6] || (_cache[6] = $event => {
        $setup.closeSidebar();
        $setup.gaTrackButtonClick('leftmenu-skill-path');
        $setup.routerPush($event);
      })
    }, {
      default: _withCtx(() => [_cache[23] || (_cache[23] = _createElementVNode("div", null, [_createElementVNode("svg", {
        viewBox: "0 0 34 34",
        class: "sidebar-logo"
      }, [_createElementVNode("use", {
        "xlink:href": "#skill-path"
      })])], -1)), !$setup.sidebar.states.isSidebarClose ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t("SIDEBAR.SKILL_PATH")), 1)) : _createCommentVNode("", true), _cache[24] || (_cache[24] = _createElementVNode("div", {
        class: "label",
        style: {}
      }, "New", -1))]),
      _: 1
    }, 8, ["data-content"]), _createVNode(_component_el_menu_item, {
      index: "master-class",
      class: "tooltip",
      "data-content": _ctx.$t('SIDEBAR.MASTER_CLASS'),
      onClick: _cache[7] || (_cache[7] = $event => {
        $setup.closeSidebar();
        $setup.gaTrackButtonClick('leftmenu-masterclass');
        $setup.routerPush($event);
      })
    }, {
      default: _withCtx(() => [_cache[25] || (_cache[25] = _createElementVNode("div", null, [_createElementVNode("svg", {
        viewBox: "0 0 34 34",
        class: "sidebar-logo"
      }, [_createElementVNode("use", {
        "xlink:href": "#master-class"
      })])], -1)), !$setup.sidebar.states.isSidebarClose ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t("SIDEBAR.MASTER_CLASS")), 1)) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["data-content"]), _createVNode(_component_el_menu_item, {
      index: "webinar",
      class: "tooltip",
      "data-content": _ctx.$t('SIDEBAR.WEBINAR'),
      onClick: _cache[8] || (_cache[8] = $event => {
        $setup.closeSidebar();
        $setup.gaTrackButtonClick('leftmenu-webinar');
        $setup.routerPush($event);
      })
    }, {
      default: _withCtx(() => [_cache[26] || (_cache[26] = _createElementVNode("div", null, [_createElementVNode("svg", {
        viewBox: "0 0 34 34",
        class: "sidebar-logo"
      }, [_createElementVNode("use", {
        "xlink:href": "#webinar"
      })])], -1)), !$setup.sidebar.states.isSidebarClose ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t("SIDEBAR.WEBINAR")), 1)) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["data-content"]), _cache[30] || (_cache[30] = _createElementVNode("div", {
      class: "rl-row-10"
    }, [_createElementVNode("div", {
      class: "divide-line"
    })], -1)), _createVNode(_component_el_menu_item, {
      index: "bookmark",
      class: "tooltip",
      "data-content": _ctx.$t('SIDEBAR.BOOKMARK'),
      onClick: _cache[9] || (_cache[9] = $event => {
        $setup.closeSidebar();
        $setup.gaTrackButtonClick('leftmenu-bookmark');
        $setup.routerPush($event);
      })
    }, {
      default: _withCtx(() => [_cache[27] || (_cache[27] = _createElementVNode("div", null, [_createElementVNode("svg", {
        viewBox: "0 0 34 34",
        class: "sidebar-logo"
      }, [_createElementVNode("use", {
        "xlink:href": "#bookmark_1_"
      })])], -1)), !$setup.sidebar.states.isSidebarClose ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t("SIDEBAR.BOOKMARK")), 1)) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["data-content"]), _createVNode(_component_el_menu_item, {
      index: "history",
      class: "tooltip",
      "data-content": _ctx.$t('SIDEBAR.HISTORY'),
      onClick: _cache[10] || (_cache[10] = $event => {
        $setup.closeSidebar();
        $setup.gaTrackButtonClick('leftmenu-history');
        $setup.routerPush($event);
      })
    }, {
      default: _withCtx(() => [_cache[28] || (_cache[28] = _createElementVNode("div", null, [_createElementVNode("svg", {
        viewBox: "0 0 34 34",
        class: "sidebar-logo"
      }, [_createElementVNode("use", {
        "xlink:href": "#history"
      })])], -1)), !$setup.sidebar.states.isSidebarClose ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t("SIDEBAR.HISTORY")), 1)) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["data-content"]), _cache[31] || (_cache[31] = _createElementVNode("div", {
      class: "rl-row-10"
    }, [_createElementVNode("div", {
      class: "divide-line"
    })], -1)), _createVNode(_component_el_menu_item, {
      index: "online-manual",
      class: "tooltip",
      "data-content": _ctx.$t('SIDEBAR.ONLINE_MANUAL'),
      onClick: _cache[11] || (_cache[11] = $event => {
        $setup.closeSidebar();
        $setup.gaTrackButtonClick('leftmenu-online-manual');
        $setup.routerPush($event);
      })
    }, {
      default: _withCtx(() => [_cache[29] || (_cache[29] = _createElementVNode("div", null, [_createElementVNode("svg", {
        viewBox: "0 0 34 34",
        class: "sidebar-logo"
      }, [_createElementVNode("use", {
        "xlink:href": "#manual"
      })])], -1)), !$setup.sidebar.states.isSidebarClose ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t("SIDEBAR.ONLINE_MANUAL")), 1)) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["data-content"])]),
    _: 1
  }, 8, ["default-active", "collapse"]), _createElementVNode("div", _hoisted_16, [_createElementVNode("a", {
    href: 'https://www.reallusion.com' + $setup.currentLangPath,
    target: "_blank",
    onClick: _cache[12] || (_cache[12] = $event => $setup.gaTrackButtonClick('leftmenu-rl-logo'))
  }, [(_openBlock(), _createElementBlock("svg", {
    viewBox: "0 0 500 49.987",
    class: "rl-logo-l",
    style: _normalizeStyle({
      'display': $setup.sidebar.states.isSidebarClose ? 'none' : 'block'
    })
  }, _cache[32] || (_cache[32] = [_createElementVNode("use", {
    "xlink:href": "#rl-logo-l"
  }, null, -1)]), 4)), (_openBlock(), _createElementBlock("svg", {
    viewBox: "0 0 34 34",
    class: "rl-logo-s",
    style: _normalizeStyle({
      'display': !$setup.sidebar.states.isSidebarClose ? 'none' : 'block'
    })
  }, _cache[33] || (_cache[33] = [_createElementVNode("use", {
    "xlink:href": "#rl-logo-s"
  }, null, -1)]), 4))], 8, _hoisted_17)])], 2)], 64);
}